import { flyIn, fadeIn, overlay, overlayFade, slideIn, animateOpen, paymentmethod, paymenticon, paymentwindow, payment, paymentresult, accountpayment, paypalpayment, terms, paymenterror, bottomLine, showShipping, dropIn, fadeAway, noItems, cartDiscount, checkoutRemoved, checkoutItem, cartCard, specialItem, cartLoader, loader, fader } from './checkout.animations';
import { rotateDown, rotateOpen } from '../animations';
import { ViewChild, Component, OnInit, Injectable, Inject, HostListener, trigger, state, animate, style, group, transition, keyframes, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { Angulartics2 } from 'angulartics2';
import { UserService } from '../../services/user.service';
import { StoreService } from '../../services/store.service';
import { Filter } from '../../models/filter.constructor';

import { environment } from '../../environment';

import { Item } from '../../models/item';
import { Order } from '../../models/order';
import { Method } from '../../models/method';
import { Country } from '../../models/country';
import { Account } from '../../models/account';
import { Product } from '../../models/product';
import { Currency } from '../../models/currency';
import { PaymentProduct } from '../../models/paymentproduct';

declare var $: any;

@Component({
	selector: 'app-checkout',
	templateUrl: './checkout.component.html',
	providers: [ StoreService, UserService ],
	animations: [
		terms,
		flyIn,
		loader,
		fader,
		fadeIn,
		fadeAway,
		cartCard,
		overlay,
		payment,
		cartLoader,
		specialItem,
		overlayFade,
		paymentmethod,
		paymentwindow,
		paymenticon,
		paymentresult,
		accountpayment,
		paypalpayment,
		showShipping,
		paymenterror,
		checkoutItem,
		cartDiscount,
		checkoutRemoved,
		noItems,
		bottomLine,
		rotateOpen,
		animateOpen,
		rotateDown,
		animateOpen,
		slideIn,
		dropIn
	]
})
export class CheckoutComponent implements OnInit {

	// Global Exports
	accounts: 			Account;

	countries: 			Country;

	currency:			Currency;
	currencies: 		Currency;

	form: 				FormGroup;
	method: 			Method;
	order:				Order;

	products: 			Product;
	removedproducts: 	Product;
	backupproducts: 	Product;
	allproducts: 		Product;
	features: 			Product;

	items: 				Item;
	backupitems: 		Item;
	removeditems: 		Item;
	requiredItems: 		Item;

	paymentProducts: PaymentProduct;

	// Models
	profile = new Shipping();
	options = new ProductOptions();
	paymentDetails = new PaymentDetails();
	credit = new CreditCard(null,null,null,'',1,false);
	
	// Account
	username: string;
	email: string;

	// Checkout Variables
	environment = environment;
	title: any;
	header: any;
	subtitle: string;

	// Cart
	cart: number;
	dragging: any[];
	cartItems: any[];
	cartProducts: any[];

	// Undo
	undoItems: any;
	undoProducts: any;
	recoverItems: any;
	recoverProducts: any;

	// Checkout
	sort: string;
	session: any;
	termsLink: any;
	orderPage: any;
	addingCash: any;
	cartLength: any;
	purchaseData: any;
	headerHeight: any;
	headerAlign: any;
	ingenecoKeys: any;
	encryptedKey: any;
	paymentmethod: any;
	hoverLeft: boolean;
	paypalCheckout: any;
	hoverRight: boolean;
	showImages: boolean;
	showPaymentFixture: any;
	quantityControls: any[];

	// Loading / Status
	requiredloading = true;
	cartloading = true;
	hosted = false;
	loading = false;
	loggedIn = false;
	hideItem = false;
	showCards = 0;
	errorCode = 0;
	total = 0;
	errorMsg = '';
	giftError = '';
	hasPassport = true;
	
	// Physical Object Handling
	shipping = false;
	editingShipping = false;
	shippingError = false;

	// Gift Status
	orderIsGift = false;
	gifting = false;
	gift = new Gift();
	
	// Payment animation states
	paymentState = 'hidden';
	paymentFixture = 'in';
	countryCode = 'US';
	bottomlinecolor = 1;
	query = new Filter();

	discount = 0;

	enableCurrencySelector = false;
	hasProducts = false;
	passportID = { ids: 1 };


	// background position
	bgX = 0;
	bgY = 0;
	bgPos = '';
	

	/**
	 * Checkout Constructor
	**/

  constructor(	private storeService: StoreService,
				private userService: UserService,
				private route: ActivatedRoute,
				private sanitizer: DomSanitizer,
				private router: Router,
				private track: Angulartics2) {
	}


	/* Mouse Movements */
	@HostListener('mousemove', ['$event'])
	onMousemove(event: MouseEvent) {
	this.bgX   = -(event.clientX/10);
	this.bgY   = -(event.clientY/10);
	this.bgPos = this.bgX+'px '+this.bgY+'px';
	}

	/**
	* Add Product
	**/

	// Add product to cart
	addToCart(product) {
		if (product.id) {
			this.storeService.addToCart(product.id);
			this.totalCart();
			this.countCart();
			this.products = null;
			this.cartloading = true;
			this.updateCartView();
		}
	}

	// Add item to cart
	addItemToCart(item) {
		if (item.id) {
			this.storeService.addItem(item.id);
			this.totalCart();
			this.countCart();
			this.items = null;
			this.cartloading = true;
			this.updateCartView();
		}
	}

	resetUndo() {
		this.undoItems = 0;
		this.undoProducts = 0;
		this.removeditems = null;
		this.removedproducts = null;
	}


	/**
	* Remove from Cart
	**/
	removeFromCart(productId, i?) {
		this.resetUndo();
		this.undoItems = 0;
		this.undoProducts = 0;
		this.removeditems = null;
		this.removedproducts = null;
		let count = this.storeService.removeFromCart(productId);
		if ( count == 0 ) this.undoProducts = productId;
		this.updateCartView();
		setTimeout( () => {
			this.resetUndo();
		}, 20000);
	}

	removeItemFromCart(item, i?) {
		this.resetUndo();
		let count = this.storeService.removeItem( item.id );
		if ( count == 0 ) this.undoItems = item.id;
		this.updateCartView();
		setTimeout( () => {
			this.resetUndo();
		}, 20000);
	}


	/**
	* Remove a product from the cart
	**/
	removeCompletely(product, i?) {
		product.quantity = 0;
		this.changeQuantity(product);
	}

	// Remove an item from the cart
	removeItemCompletely(item, i?) {
		item.quantity = 0;
		this.changeItemQuantity(item);
	}


	/**
	* Add a gift to the cart
	**/
	checkGift() {
		if ( this.gift.username == this.username || this.gift.username == this.email ) {
			this.giftError = 'Check Account';
			setTimeout( () => { this.giftError = ''; }, 500);
			return;
		} else {
			this.hasPassport = true;
			Promise.resolve( this.storeService.setGiftUser(this.gift.username) ).then( (name) => {
				if ( name != false )  {
					this.gifting = true;
					this.gift.username = name;
					this.products = null;
					this.totalCart();
					this.updateCartView();
				} else { 
					this.giftError = 'Error with Email / User';
					setTimeout( () => { this.giftError = ''; }, 2100);
				}
				return;
			});
		}
	}


	/**
	* Remove the gift username from the cart
	**/
	removeGift() {
		Promise.resolve( this.storeService.removeGiftUser() ).then( () => {
			this.gifting = false;
			this.orderIsGift = false;
			this.gift.username = '';
			this.products = null;
			this.totalCart();
			this.updateCartView();
		});
	}


	/**
	* Toggle gifting
	**/
	giftToggle() {
		this.orderIsGift = (this.orderIsGift==false) ? true : false;
		if ( this.gift.username ) {
			this.products = null;
			this.totalCart();
			this.updateCartView();	
		}
	}


	/**
	* Empty all the items from the cart
	**/

	emptyCart() {
		this.storeService.clearCart();

		this.recoverProducts = this.cartProducts;
		this.backupproducts = this.products;
		this.recoverItems = this.cartItems;
		this.backupitems = this.items;

		this.removedproducts = null;
		this.removeditems = null;

		this.cartProducts = null;
		this.cartItems = null;

		this.undoProducts = null;
		this.undoItems = null;

		this.products = null;
		this.items = null;

		this.total = 0;
		this.cart = 0;

		this.countCart();
		this.totalCart();
	}


	restoreCart() {

		this.products = this.backupproducts;
		this.items = this.backupitems;
		this.cartProducts = this.recoverProducts;
		this.cartItems = this.recoverItems;

		this.backupproducts = null;
		this.backupitems = null;
		this.recoverProducts = null;
		this.recoverItems = null;

		this.storeService.setCartContents(this.cartProducts);
		this.storeService.setItemContents(this.cartItems);

		this.updateCartView();

		this.countCart();
		this.totalCart();
	}


	/**
	* Change Quantity
	**/
	changeQuantity(p) {
		let updatedQuantity = this.storeService.changeQuantity(p.id, p.quantity);
		if ( updatedQuantity == 0 ) this.undoProducts = p.id;
		// this.updateCartView();
		this.updateUndo();
		this.countCart();
		this.totalCart();
	}
	
	changeItemQuantity(i) {
		if ( i.quantity > i.limit ) i.quantity = i.limit;
		let updatedQuantity = this.storeService.changeItemQuantity(i.id, i.quantity);
		if ( updatedQuantity == 0 ) this.undoItems = i.id;
		// this.updateCartView();
		this.updateUndo();
		this.countCart();
		this.totalCart();
	}


	updateUndo() {
		if ( this.undoProducts ) { 
			Promise.resolve( this.storeService.getProducts(this.undoProducts) ).then((productData) => {
				this.removedproducts = productData;
			});
		}

		if ( this.undoItems ) {
			this.query.ids = this.undoItems; 
			Promise.resolve( this.storeService.getItems(this.query) ).then((itemData) => {
				this.removeditems = itemData;
			});
		}
	}

	updateCartView() {

		this.cartProducts = this.storeService.getCartContents();
		this.cartItems = this.storeService.getItemContents();
		this.cart = this.cartItems.length + this.cartProducts.length;

		Promise.resolve( this.storeService.getCartProducts(this.cartProducts, this.orderIsGift) ).then( (productData) => {
			this.products = productData;

			for (var i = this.cartProducts.length - 1; i >= 0; i--) {
				if ( this.products[i].price == 0 ) {
					this.removeCompletely( this.products[i] );
				}
			}

		});

		Promise.resolve( this.storeService.getSpecificItems(this.cartItems) ).then( (itemData) => {
			this.items = itemData;
			this.cartloading = false;
			this.totalCart();
		});

		if ( this.undoProducts ) { 
			Promise.resolve( this.storeService.getProducts(this.undoProducts) ).then((productData) => {
				this.removedproducts = productData;
			});
		}

		if ( this.undoItems ) {
			this.query.ids = this.undoItems; 
			Promise.resolve( this.storeService.getItems(this.query) ).then((itemData) => {
				this.removeditems = itemData;
			});
		}
	}



	totalCart() {

		Promise.resolve( this.storeService.getCartTotal(this.passportID.ids, this.orderIsGift) ).then((result) => {
			
			if ( this.currency ) {
				this.total = result.total * this.currency.value;
				this.discount = result.discount * this.currency.value;
			} else {
				this.total = result.total;
				this.discount = result.discount;
			}

			if ( this.total < 50 ) this.bottomlinecolor = 1;
			if ( this.total > 50 ) this.bottomlinecolor = 2;
			if ( this.total > 100 ) this.bottomlinecolor = 3;
			if ( this.total > 1000 ) this.bottomlinecolor = 4;

			this.hasPassport = ( this.gifting ) ? true : result.hasRequired;
			this.shipping = result.shipping;

		});
	}



	/**
	* Handle the Purchase
	**/

	purchase() {

		if ( this.credit.terms === false ) {

			this.errorCode = 300;
			this.errorMsg = 'Please agree to the terms of service.';
			
		} else if ( this.credit.terms == true ) {

			this.errorCode = 100;
			this.errorMsg = 'Sending payment...';
			this.loading = true;

			this.paymentDetails.totalAmount = this.total*100;
			this.paymentDetails.currency = this.currency.symbol;
			this.paymentDetails.countryCode = this.countryCode;
			this.paymentDetails.isRecurring = false;
			this.paymentDetails.locale = "en_US";
			let giftUser = this.orderIsGift ? this.gift.username : null;

			Promise.resolve( this.storeService.paymentRequest( this.credit, this.paymentDetails ) ).then( (paymentProduct) => {

				Promise.resolve( this.storeService.encryptData( this.credit, paymentProduct ) ).then( ( encryptedNumbers ) => {

					Promise.resolve( this.storeService.purchaseItems( this.paymentState, encryptedNumbers, giftUser ) ).then( (order) => {

						// Handle the server return
						this.order = order;
						// this.loading = false;
						this.errorCode = this.order[0].code;

						if(this.errorCode != 200) {

							// Assign the error code to the frontend
							this.errorMsg = this.order[0].err;
						} else if (this.errorCode == 200) {
							// A payment was successfully made
							this.finishCheckout();
							this.authorize();
						}

					}).catch(function (err) {

						// The backend was not reached
						this.errorCode = 500;
						this.errorMsg = 'Error sending payment.';

					});

				});
			});

		}

		// Reset the error result after a time on screen
		setTimeout (() => { this.errorCode = 0; this.errorMsg = ''; }, 10000);
	}



	/**
	* Handle the Purchase with Account Credits
	**/

	purchaseWithAccountCredits() {

		if ( this.credit.terms === false ) {

			this.errorCode = 300;
			this.errorMsg = 'Please agree to the terms of service.';
			
		} else if ( this.credit.terms == true ) {

			this.errorCode = 100;
			this.errorMsg = 'Sending payment...';
			this.loading = true;

			this.paymentDetails.totalAmount = this.total*100;
			this.paymentDetails.currency = this.currency.symbol;
			this.paymentDetails.countryCode = this.countryCode;
			this.paymentDetails.isRecurring = false;
			this.paymentDetails.locale = "en_US";

			Promise.resolve( this.storeService.purchaseItems( this.paymentState, {}, this.gift.username ) ).then( (order) => {

				// Handle the server return
				this.order = order;
				this.loading = false;
				this.errorCode = this.order[0].code;

				if(this.errorCode != 200) {
					// Assign the error code to the frontend
					this.errorMsg = this.order[0].err;
				} else if (this.errorCode == 200) {
					// A payment was successfully made
					this.finishCheckout();
					this.authorize();
				}

			}).catch(function (err) {

				// The backend was not reached
				this.errorCode = 500;
				this.errorMsg = 'Error sending payment.';

			});

		}

		// Reset the error result after a time on screen
		setTimeout (() => { this.errorCode = 0; this.errorMsg = ''; }, 10000);
	}



	/**
	 * Window animations and triggers
	**/

	// Trigger opening the payment window for the appropriate service
	openPaymentWindow( service ) {
		if ( this.hasPassport ) {
			this.errorCode = 0;
			this.credit.terms = false;
			this.paymentState = service;
			this.paypalCheckout = null;
			this.showPaymentFixture = true;
		
			if (this.paymentState == 'gc') {
				this.paymentFixture = '1';
			} else if (this.paymentState == 'paypal') {
				this.paymentFixture = '5';
				this.hosted = false;
			} else if (this.paymentState == 'paypal-hosted') {
				this.paymentFixture = '5';
				this.hosted = true;
			} else if (this.paymentState == 'account') {
				this.paymentFixture = '3';
			}
		}
	}

	showTerms() {
		this.orderPage = this.paymentFixture;
		this.paymentFixture = '4';
	}

	backToOrder() {
		this.paymentFixture = this.orderPage;
	}

	// Generate a new hosted checkout URL
	paypalHostedCheckout() {
		this.paypalCheckout = null;
		this.errorCode = 0;
		if ( this.credit.terms == true && this.total > 0 ) {
			Promise.resolve( this.storeService.paypalHostedCheckout(null, this.orderIsGift) ).then((data) => { 
				this.paypalCheckout = data;
			});
		}
	}

	checkHostedPayPal() {
		if ( this.credit.terms === false ) {

			this.errorCode = 300;
			this.errorMsg = 'Please agree to the terms of service.';
			
		} else if ( this.credit.terms == true ) {

			this.errorCode = 100;
			this.errorMsg = 'Authorizing with PayPal...';
			let paypalPurchase = setInterval( () => {
				Promise.resolve( this.storeService.checkPayPalHosted() ).then((order) => {
					
					// Handle the server return
					this.loading = false;
					this.order = order;
					this.errorCode = this.order[0].code;

					if(this.errorCode != 200) {
						// Assign the error code to the frontend
						this.errorMsg = this.order[0].err;
						clearInterval(paypalPurchase);
					} else if (this.errorCode == 200) {
						// A payment was successfully made
						this.finishCheckout()
						clearInterval(paypalPurchase);
					}

				}).catch(function (err) {
					// The backend was not reached
				});

			}, 5000);

			setTimeout( function() { clearInterval(paypalPurchase); }, 80000);
		}
	}

	finishCheckout() {

		if ( this.cartProducts ) this.track.eventTrack.next({ action: 'Purchase', properties: { content_ids: this.cartProducts, content_type:'product', value: this.total, currency: this.currency.name }});
		if ( this.cartItems ) this.track.eventTrack.next({ action: 'Purchase', properties: { content_ids: this.cartItems, content_type:'item', value: this.total, currency: this.currency.name }});

		this.errorMsg = 'Payment Complete';
		this.paymentFixture = '2';

		this.storeService.clearCart();
	}



	updateAddress() {
		this.shippingError = null;
		Promise.resolve( this.userService.updateAccount(this.profile) ).then((resp) => { 
			this.shippingError = resp[0].error;
			if ( !this.shippingError ) {
				this.accounts = resp;
				this.editingShipping = false;
			}
		});
		setTimeout (() => { this.shippingError = null; }, 10000);
	}



	/**
	* Currency Handling
	**/
	getCurrencies() {
		// if ( environment.currencies ) {
			Promise.resolve( this.storeService.getCurrencies() ).then((c) => {
				this.currencies = c;
			});

			Promise.resolve( this.storeService.getCurrency() ).then((c) => {
				this.currency = c[0];
			});

			Promise.resolve(this.storeService.enableCurrencySelector()).then((bool) => {
				this.enableCurrencySelector = bool;
			});
		// }
	}


	/**
	* Authorize a logged in user to make a purchase
	**/
	authorize() {
		// Send the authorization request
		this.userService.authorizeUser().subscribe((user) =>  {
			this.accounts = user;
			if ( user ) {
				this.loggedIn = true;

				this.username = user[0]['username'];
				this.email = user[0]['email'];

				// Load up Shipping address
				this.profile['firstname'] = user[0]['firstname'];
				this.profile['surname'] = user[0]['surname'];
				this.profile['street'] = user[0]['street'];
				this.profile['housenumber'] = user[0]['housenumber'];
				this.profile['zip'] = user[0]['zip'];
				this.profile['city'] = user[0]['city'];
				this.profile['state'] = user[0]['state'];
				this.profile['countrycode'] = user[0]['countrycode'];

				// Request data on valid payment methods for this account.
				Promise.resolve( this.storeService.getPaymentMethods(this.total) ).then((methods) => {
					this.method = methods;
				});

				// Request a GC session for encrypting credit details.
				// Promise.resolve( this.storeService.gcSession() ).then( (key) => {
				// 	this.session = key;
				// });

			}
		});
	}

	changeCurrency(currency) {
		this.currency = currency;
		this.storeService.changeCurrency(currency);
	}

	getCountries() {
		Promise.resolve( this.userService.getCountryCodes() ).then((countries) => { 
			this.countries = countries;
		});
	}

	/**
	*   Stagger In Animation !!
	** ( this took two weeks ) **
	**/

	stagger(i = 0, t = 67) {
		setTimeout( () => {
			this.showCards = i; 
			if (this.showCards < 10) {
				this.stagger(i+1, t);
			} else { 
				this.showCards = 100;
			}
		}, t);
	}


	/**
	* Drag items around
	**/
	dragUndo(z) {
		this.dragging[z] = true;
	}

	dropUndo(z) {
		this.dragging[z] = false;
	}

	addCash() {
		this.addingCash = false;
	}

	countCart() {
		Promise.resolve( this.storeService.countCartContents() ).then( ( count ) => {
			this.cartLength = count;
		});
	}

	/* On with the show */
	ngOnInit() {

		this.authorize();
		

		Promise.resolve( this.storeService.getGiftUser() ).then( (name) => {
			if ( name ) {
				this.gifting = true;
				this.orderIsGift = true;
				this.gift.username = name;
			}

			this.updateCartView();
		});

		

		// Page defaults
		this.title = 'IDENTITY STORE';
		this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-faq.jpg")' );
		this.subtitle = 'Changing what it means to be an MMORPG.';
		this.headerHeight = '350px';

		// Sort products
		this.sort = 'asc';

		// Sort products
		// this.gift.cash = 1000;

		this.getCountries();
		
		// Get currencies
		this.getCurrencies();
		this.countCart();
		
		// setTimeout( () => { this.hasPassport = false; }, 500)

		Promise.resolve( this.storeService.getItems(this.passportID) ).then( (those) => {
			this.requiredItems = those;
			this.requiredloading = false;
		});

		this.track.eventTrack.next({ action: 'InitiateCheckout' });

	}

	createRange(number) {
		var items: number[] = [];
		for(var i = 1; i <= number; i++) { items.push(i); }		
		return items;
	}



	/**
	* JQuery Events to fire after initialization
	**/
	ngAfterViewInit() {
		let fields = ['[name="email"]','[name="confirmpassword"]','.birthday input']
		for (var i = fields.length - 1; i >= 0; i--) {
			$(fields[i]).on('keydown', function(e) { 
				if (e.keyCode == 9) {
					e.preventDefault();
					$(this).focus();
				}
			});
		}
	}


}

/**
 * Models for each form on the page
**/ 


// Export the constructor Shipping form
export class Shipping {

	constructor(
		public firstname?: string,
		public surname?: string,
		public street?: string,
		public housenumber?: string,
		public zip?: string,
		public city?: string,
		public state?: string,
		public countrycode?: string
	) {}

}


// This constructor generates the Login form
export class CreditCard {
  constructor(
	public cardholderName?: string,
	public cardNumber?: number,
	public cvv?: number,
	public expiryDate?: string,
	public paymentProductId?: any,
	public terms?: boolean
  ) {}
}


// This constructor generates the Login form
export class PaymentDetails {
  constructor(
	public totalAmount?: number,
	public currency?: string,
	public countryCode?: string,
	public isRecurring?: boolean,
	public locale?: string
  ) {}
}

export class ProductOptions {
	constructor(
		public quantity?: string
	) {}
}


export class Gift {
	constructor(
		public username?: string,
		public cash?: number
	) {}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/store/checkout/checkout.component.ts